import {
  createBrowserRouter,
  RouterProvider,
  Outlet,
} from "react-router-dom";
import { ScrollToTop } from "./components/ScrollToTop";
import { Header } from "@/components/site/Header";
import { Footer } from "@/components/site/Footer";

import Index from "./pages/Index";
import ContactPage from "./pages/ContactPage";
import BlogPage from "./pages/BlogPage";
import BlogPostPage from "./pages/BlogPostPage";
import ProjectCyberscapePage from "./pages/portfolio/ProjectCyberscapePage";
import EtherealThreadsPage from "./pages/portfolio/EtherealThreadsPage";
import QuantumLeapPage from "./pages/portfolio/QuantumLeapPage";
import AudioVisualizerPage from "./pages/portfolio/AudioVisualizerPage";
import { ShopPage } from "./pages/ShopPage";
import EntheaPage from "./pages/EntheaPage";
import { NIP19Page } from "./pages/NIP19Page";
import NotFound from "./pages/NotFound";

const router = createBrowserRouter([
  {
    element: (
      <>
        <ScrollToTop />
        <Header />
        <main>
          <Outlet />
        </main>
        <Footer />
      </>
    ),
    children: [
      { path: "/", element: <Index /> },
      { path: "/contact", element: <ContactPage /> },
      { path: "/blog", element: <BlogPage /> },
      { path: "/blog/:slug", element: <BlogPostPage /> },
      { path: "/portfolio/project-cyberscape", element: <ProjectCyberscapePage /> },
      { path: "/portfolio/ethereal-threads", element: <EtherealThreadsPage /> },
      { path: "/portfolio/quantum-leap", element: <QuantumLeapPage /> },
      { path: "/audio-visualizer", element: <AudioVisualizerPage /> },
      { path: "/shop", element: <ShopPage /> },
      { path: "/enthea", element: <EntheaPage /> },
      // NIP-19 route for npub1, note1, naddr1, nevent1, nprofile1
      { path: "/:nip19", element: <NIP19Page /> },
      // ADD ALL CUSTOM ROUTES ABOVE THE CATCH-ALL "*" ROUTE
      { path: "*", element: <NotFound /> },
    ],
  },
]);

export function AppRouter() {
  return <RouterProvider router={router} />;
}

export default AppRouter;
